/** Barrier opening modes */
export enum BarrierOpenModeEnum {
  /** Open by "NetPing" device */
  NET_PING_DEVICE = 'NET_PING_DEVICE',
  /** Open by "IronLogic" converter */
  CONVERTER = 'CONVERTER',
  /** Open by "Hikvision" camera API ("ISAPI") */
  ISAPI = 'ISAPI',
}
